import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            companyName: '',
            translations: [],
            newTranslation: {
                key: "",
                valueFirst: "",
                valueSecond: "",
                itemFirst: null,
                itemSecond: null
            },
            languages: [
                {
                    id: 'sr',
                    name: 'Srpski',
                },
                {
                    id: 'en',
                    name: 'English',
                },
            ],
            showQrCodeItem: null,
        }
    },
    methods: {
        load: load,
        editTranslate: editTranslate,
        addCompany: addCompany,
        deleteTranslate: deleteTranslate,
        saveTranslation: saveTranslation,
        updateTranslation: updateTranslation,
        editTranslation: editTranslation,
        copyTranslate: copyTranslate,
        reset: reset,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        }
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.companyName = this.$route.query.companyName;
        if(CONFIG_COMPANY.LANGUAGES != null){
            this.languages = CONFIG_COMPANY.LANGUAGES;
        }
        this.role = session.getRole();
        this.load()
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowQrCode', () => {
            _self.showQrCodeItem = null;
        });
    }
}

function copyTranslate(){
    let _self = this;

    swal({
        title: LocService.t("company_name"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" type="text" placeholder="'+ LocService.t("company_name") +'" class="input" style="width: 50%; border-radius: 10px"  />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var fromCompany = document.getElementById('swal-input').value

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        AdminApiService.copyTranslations(fromCompany, _self.companyName)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function load() {
    let _self = this;
    AdminApiService.getTranslations(_self.companyName)
        .then((response) => {

            _self.translations = Object.entries(response.data).map(([key, values]) => {
                const id = values.find(item => item.language === _self.languages[0].id).id || 0;
                const itemFirst = values.find(item => item.language === _self.languages[0].id) || null;
                const itemSecond = values.find(item => item.language === _self.languages[1].id) || null;
                const valueFirst = itemFirst.value || "";
                const valueSecond = itemSecond.value || "";

                return {
                    id: id,
                    key: key,
                    valueFirst: valueFirst,
                    valueSecond: valueSecond,
                    itemFirst: itemFirst,
                    itemSecond: itemSecond,
                };
            })
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteTranslate(item){
    let _self = this;

    swal({
        title: "Da li ste sigurni?",
        text: "Da li ste sigurni da zelite da obrisete prevod: " + item.key +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            key: item.key,
            company: _self.companyName
        }
        AdminApiService.deleteTranslations(model)
            .then((response) => {
                swal(LocService.t('label_success'), "Uspešno obrisan prevod.", 'success')
                _self.load();
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function editTranslation(item){
    this.newTranslation.key = item.key;
    this.newTranslation.valueFirst = item.valueFirst;
    this.newTranslation.valueSecond = item.valueSecond;
    this.newTranslation.itemFirst = item.itemFirst;
    this.newTranslation.itemSecond = item.itemSecond;

}

function updateTranslation(){
    let _self = this;
    if(_self.newTranslation.key.length === 0 ||
        _self.newTranslation.valueFirst.length === 0 ||
        _self.newTranslation.valueSecond.length === 0){
        swal(LocService.t('label_error'), 'Sva polja obavezna', 'error')
        return;
    }
    var model = {
        data: [],
        company: this.companyName
    }
    var index = 0;
    this.languages.forEach(l => {
        var item = {
            id: index === 0 ? _self.newTranslation.itemFirst.id : _self.newTranslation.itemSecond.id,
            language: l.id,
            key: _self.newTranslation.key,
            value: index === 0 ? _self.newTranslation.valueFirst : _self.newTranslation.valueSecond
        }
        model.data.push(item);
        index = index + 1;
    })
    AdminApiService.updateTranslations(model)
        .then((response) => {
            swal(LocService.t('label_success'), 'Uspesno dodati prevodi', 'success')
            _self.load();
            _self.reset();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function saveTranslation(){
    let _self = this;
    if(_self.newTranslation.key.length === 0 ||
        _self.newTranslation.valueFirst.length === 0 ||
        _self.newTranslation.valueSecond.length === 0){
        swal(LocService.t('label_error'), 'Sva polja obavezna', 'error')
        return;
    }
    console.log(_self.newTranslation)
    if(_self.newTranslation.itemFirst != null && _self.newTranslation.itemSecond != null){
        _self.updateTranslation();
        return;
    }
    var model = {
        data: [],
        company: this.companyName
    }
    var index = 0;
    this.languages.forEach(l => {
        var item = {
            language: l.id,
            key: _self.newTranslation.key,
            value: index === 0 ? _self.newTranslation.valueFirst : _self.newTranslation.valueSecond
        }
        model.data.push(item);
        index = index + 1;
    })
    AdminApiService.addTranslations(model)
        .then((response) => {
            swal(LocService.t('label_success'), 'Uspesno dodati prevodi', 'success')
            _self.reset();
            _self.load();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function reset(){
    this.newTranslation = {
        key: "",
        valueFirst: "",
        valueSecond: "",
        itemFirst: null,
        itemSecond: null
    }
}

function editTranslate(company) {
}

function addCompany() {

}


// WEBPACK FOOTER //
// ./src/components/Company/Translation.js